// CSS: blinking animation, typewriter placeholder, offset results box, search icon removal
function insertSearchBox() {
  const nav = document.querySelector(".shopify-section-group-header-group.shopify-section--header > height-observer");
  if (!nav) return false;

  let searchInput = document.querySelector(".persistent-mobile-search__search-input");
  if (!searchInput) { 
    searchInput = document.querySelector(".header-search__input");
  }
  const typewriterSpan = document.querySelector(".typewriter-placeholder");
  const resultsBox = document.querySelector('#header-predictive-search [slot="results"]');
  const clearBtn = document.querySelector(".persistent-mobile-search__clear-btn");

  // Hide/show typewriter on focus/input/blur
  function handleTypewriterVisibility() {
    if (!typewriterSpan) { return }
    // Always hide placeholder when input is focused (even when empty)
    typewriterSpan.style.display =
      document.activeElement === searchInput
        ? "none"
        : searchInput.value === ""
        ? "flex"
        : "none";
  }

  if (typewriterSpan) {  
    searchInput.addEventListener("focus", handleTypewriterVisibility);
    searchInput.addEventListener("input", handleTypewriterVisibility);
    searchInput.addEventListener("blur", handleTypewriterVisibility);
    
    // Typing animation
    const keywords = document.querySelector("#persistent-mobile-search").dataset.keywords.split(",");
    const baseText = "Search for ";
    let keywordIndex = 0;
    let charIndex = 0;
    let deleting = false;
    function typePlaceholder() {
      if (!keywords) { return }
      let current = keywords[keywordIndex];
      let text = "";
      if (!deleting) {
        charIndex++;
        text = baseText + current.slice(0, charIndex);
        if (charIndex > current.length) {
          setTimeout(function () {
            deleting = true;
            typePlaceholder();
          }, 1100);
          return;
        }
      } else {
        charIndex--;
        text = baseText + current.slice(0, charIndex);
        if (charIndex < 0) {
          deleting = false;
          keywordIndex = (keywordIndex + 1) % keywords.length;
          text = baseText;
        }
      }
      typewriterSpan.innerHTML = text + `<span class="blinking-cursor">|</span>`;
      setTimeout(typePlaceholder, deleting ? 45 : 75);
    }
    typePlaceholder();
  
    searchInput.addEventListener("input", function () {
      clearBtn.style.display = searchInput.value.length > 0 ? "inline" : "none";
      handleTypewriterVisibility();
    });

    searchInput.addEventListener("blur", function () {
      handleTypewriterVisibility();
    });
    searchInput.addEventListener("focus", function () {
      handleTypewriterVisibility();
    });
  } else {
    searchInput.addEventListener("input", function () {
      clearBtn.style.display = searchInput.value.length > 0 ? "inline" : "none";
    });
  }

  clearBtn.addEventListener("click", function () {
    searchInput.value = "";
    searchInput.focus();
    clearBtn.style.display = "none";
    resultsBox.innerHTML = "";
    handleTypewriterVisibility();
  });

  return true;
}

const observer = new MutationObserver(function (mutationsList, observer) {
  if (insertSearchBox()) {
    observer.disconnect();
  }
});
observer.observe(document.body, { childList: true, subtree: true });
insertSearchBox();